import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AppOwnerTableProps, appOwnerTable } from '@/types/appOwner';

const initialState: appOwnerTable = {
  AppOwnerTableData: {
    totalPages: 0,
    page: 1,
    data: null,
    searchText: '',
    filterValue: null,
    planFilter: null,
    sortKey: 'created_at',
    sortDirection: 'desc',
  },
  chartTimeRange: 'monthly',
};

const appOwnerTableSlice = createSlice({
  name: 'appOwnerTable',
  initialState,
  reducers: {
    setAppOwnerTableData: (state, action: PayloadAction<AppOwnerTableProps>) => {
      state.AppOwnerTableData = action.payload;
    },
    setAppOwnerTablePageAction: (state, action: PayloadAction<number>) => {
      state.AppOwnerTableData.page = action.payload;
    },
    setAppOwnerTableSearchTextAction: (state, action: PayloadAction<string>) => {
      state.AppOwnerTableData.searchText = action.payload;
      state.AppOwnerTableData.page = 1;
    },
    setAppOwnerTableFilterValueAction: (state, action: PayloadAction<number>) => {
      state.AppOwnerTableData.filterValue = action.payload;
    },
    setAppOwnerPlanFilterValueAction: (state, action: PayloadAction<number>) => {
      state.AppOwnerTableData.planFilter = action.payload;
    },
    setAppOwnerSortAction: (state, action: PayloadAction<{ sortKey: string; sortDirection: 'asc' | 'desc' }>) => {
      state.AppOwnerTableData.sortKey = action.payload.sortKey;
      state.AppOwnerTableData.sortDirection = action.payload.sortDirection;
    },

    archiveCompanyAction: (state, action: PayloadAction<number>) => {
      if (state.AppOwnerTableData.data) {
        state.AppOwnerTableData.data = state.AppOwnerTableData.data.filter((data: any) => data.id !== action.payload);
      }
    },
    setChartTimeRange: (state, action: PayloadAction<string>) => {
      state.chartTimeRange = action.payload;
    },

    clearAppOwnerTableState: () => initialState,
  },
});

export const {
  setAppOwnerTableData,
  setAppOwnerTablePageAction,
  setAppOwnerTableSearchTextAction,
  setAppOwnerTableFilterValueAction,
  setAppOwnerPlanFilterValueAction,
  setAppOwnerSortAction,
  setChartTimeRange,
  clearAppOwnerTableState,
  archiveCompanyAction,
} = appOwnerTableSlice.actions;

export default appOwnerTableSlice.reducer;
